import React from "react";
import { Select, Form } from "antd";
import styled from "styled-components";

const StyledFormItem = styled(Form.Item)`
  position: relative;
  margin-bottom: 24px;

  .ant-form-item-label {
    position: absolute;
    top: -10px;
    left: 10px;
    z-index: 1;
    margin: 0;
    padding: 0 4px;
    
    label {
      font-size: 14px;
      height: auto;
      color: rgba(0, 0, 0, 0.85);
      background: white;
      margin: 0;
      
      &::before {
        display: none;
      }

      &::after {
        display: none;
      }

      &.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
        &::after {
          display: inline-block;
          margin-left: 2px;
          color: #ff4d4f;
          font-size: 14px;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: '*';
        }
      }
    }
  }

  .ant-select {
    .ant-select-selector {
      height: 60px !important;
      padding: 8px 12px !important;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      
      .ant-select-selection-search-input {
        height: 58px !important;
      }
      
      .ant-select-selection-item {
        line-height: 42px !important;
      }
    }

    &:focus-within .ant-select-selector {
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }
`;

const EnumSelect = ({ 
  label, 
  name, 
  required, 
  message,
  options,
  ...props 
}) => {
  const rules = required ? [{ required: true, message: message || `Please select ${label.toLowerCase()}!` }] : undefined;

  return (
    <StyledFormItem
      label={label}
      name={name}
      rules={rules}
    >
      <Select options={options} {...props} />
    </StyledFormItem>
  );
};

export default EnumSelect;
